import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=249f0cce"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=249f0cce&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249f0cce')) {
      api.createRecord('249f0cce', component.options)
    } else {
      api.reload('249f0cce', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=249f0cce", function () {
      api.rerender('249f0cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/404-pages/PageNotFound.vue"
export default component.exports